import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import * as routes from 'core/routing/constants/index'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Empty } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'

import ModelGroupItem from './model-group-item'
import { configuratorShape } from '../shapes'

const ModelWrapper = styled(Row)``

const renderList = modelsGroupList =>
  modelsGroupList.map(model => (
    <ModelGroupItem
      model={model}
      key={model.id}
      data-test="configurator-models-groups-list-brand-item"
    />
  ))

const ModelGroupsList = props => {
  const { setWizards, wizards, history, configurator, setConfigurator, intl } = props

  const { loading, getGroupsModel, groupsModel } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { brand, modelGroup, modelsGroupList } = configurator

  const desactivateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex =
      aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MODELS_GROUPS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,

        modelsGroupList: list
        // modelsList: null,
        // model: null
      })
    }

    if (groupsModel) runIt(groupsModel)
  }, [groupsModel])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_MODELS_GROUPS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    if (!modelGroup) desactivateNextStep()

    const params = {
      brand: brand.id
    }

    getGroupsModel(params)
  }, [])

  // first div => for animations
  return (
    <MainContentWrapper
      title={intl.formatMessage({
        id: 'configurator-models-groups-view-title'
      })}
      data-test="component-configurator-models-groups-list"
    >
      {loading && !modelsGroupList ? (
        <PageLoading data-test="configurator-models-groups-list-loading" />
      ) : (
        <ModelWrapper
          type="flex"
          justify="center"
          align="middle"
          gutter={16}
          data-test="configurator-models-groups-list-brand-wrapper"
        >
          {modelsGroupList ? renderList(modelsGroupList) : <Empty />}
        </ModelWrapper>
      )}
    </MainContentWrapper>
  )
}

ModelGroupsList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(ModelGroupsList))
